import { DataTable } from 'primereact/datatable';
import { TabPanel, TabView } from 'primereact/tabview';
import { Dialog } from 'primereact/dialog';
import { Toast, ToastMessage } from 'primereact/toast';
import { Column } from 'primereact/column';
import { useEffect, useRef } from 'react';
import { tipoTemplate } from './CadastroPessoa';
import { Button } from 'primereact/button';
import axios, { AxiosError } from 'axios';
import Cookies from 'js-cookie';
import * as messages from '../../utils/messages'
import { FilterMatchMode } from 'primereact/api';
import { useState } from 'react';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { ArrendamentoType, PessoaType, PlanoType, ImovelType, STATUS } from '../../db/Orm';
import API from '../../api/API';
import { Avatar } from 'primereact/avatar';
import { PiReceipt, PiThumbsDownFill, PiThumbsUpFill, PiIdentificationBadgeFill, PiFarm, PiListChecks, PiBriefcase } from 'react-icons/pi';

import { ReactComponent as AprovarIcon } from '../../images/positive.svg';
import { BsCalendar2CheckFill } from "react-icons/bs";
import { BiSolidFilePdf } from "react-icons/bi";
import { IconType } from 'react-icons';
import { IoPeopleOutline } from 'react-icons/io5';
import Auth from '../../auth/Authenticator';
import { InputTextarea } from 'primereact/inputtextarea';

type Props = {
  show: boolean
  hide: Function
  pessoas: Array<PessoaType>
  open: Function
  refresh: Function
  propriedades: Array<ImovelType>
  municipios: Array<any>
  openPropriedade: Function
  planos: Array<PlanoType>
  carregarPlanos?: Function
  arrendamentos: Array<any>
  rts: Array<any>
}
const logAxiosError = (error: AxiosError) => {
  if (error.response) {
    console.error('Response error data:', error.response.data);
    console.error('Response error status:', error.response.status);
    console.error('Response error headers:', error.response.headers);
  } else if (error.request) {
    console.error('No response received:', error.request);
  } else {
    console.error('Error message:', error.message);
  }
}
const aprovarRT = async (pessoa: PessoaType, toast: Toast | null, refresh: Function) => {
  try {
    await API.aprovarRT(pessoa.id);
    if (toast !== null)
      toast.show({ severity: 'success', summary: 'Aprovação RT', detail: 'Responsável Técnico de ' + pessoa.nome_razao + ' aprovado com sucesso!' })
    refresh()
  } catch (error) {
    const e = error as AxiosError;
    logAxiosError(e);
    if (toast !== null) {
      toast.show({ severity: 'error', summary: 'Erro na Aprovação RT', detail: e.message || 'Erro desconhecido' });
    }
  }
}
const reprovarRT = async (pessoa: PessoaType, toast: Toast | null, refresh: Function) => {
  try {
    await API.reprovarRT(pessoa.id);
    if (toast !== null)
      toast.show({ severity: 'success', summary: 'Reprovação RT', detail: 'Responsável Técnico de ' + pessoa.nome_razao + ' reprovado com sucesso!' })
    refresh()
  } catch (error) {
    const e = error as AxiosError;
    logAxiosError(e);
    if (toast !== null) {
      toast.show({ severity: 'error', summary: 'Erro na Reprovação RT', detail: e.message || 'Erro desconhecido' });
    }
  }
}
const aprovar = async (pessoa: PessoaType, toast: Toast | null, refresh: Function) => {

  axios.post(API.url + 'pessoas/' + pessoa.id + '/aprovar/', {}, { headers: { Authorization: 'Bearer ' + Cookies.get('token') } })
    .then(() => {
      if (toast !== null)
        toast.show({ severity: 'success', summary: 'Aprovação Cadastral', detail: 'Cadastro de ' + pessoa.nome_razao + ' aprovado com sucesso!' })
      refresh()
    })
    .catch(logAxiosError)
}
const reprovarPessoa = async (pessoa: PessoaType, motivo: string, toast: Toast | null, refresh: Function) => {

  axios.post(API.url + 'pessoas/' + pessoa.id + '/reprovar/', { motivo_reprovacao: motivo }, { headers: { Authorization: 'Bearer ' + Cookies.get('token') } })
    .then(() => {
      if (toast !== null)
        toast.show({ severity: 'success', summary: 'Reprovação Cadastral', detail: 'Cadastro de ' + pessoa.nome_razao + ' reprovado com sucesso!' })
      refresh()
    })
    .catch(logAxiosError)
}
const aprovarPropriedade = async (propriedade: ImovelType, toast: Toast | null, refresh: Function) => {

  axios.post(`${API.url}propriedades/${propriedade.id}/aprovar/`, {}, { headers: { Authorization: 'Bearer ' + Cookies.get('token') } })
    .then(() => {
      if (toast !== null)
        toast.show({ severity: 'success', summary: 'Aprovação Cadastral', detail: 'Cadastro de ' + propriedade.nome + ' aprovado com sucesso!' })
      refresh()
    })
    .catch((e) => {
      console.log('Error', e)
    })
}
const reprovarPropriedade = async (propriedade: ImovelType, motivo: string, toast: Toast | null, refresh: Function) => {

  axios.post(API.url + 'propriedades/' + propriedade.id + '/reprovar/', { motivo_reprovacao: motivo }, { headers: { Authorization: 'Bearer ' + Cookies.get('token') } })
    .then(() => {
      if (toast !== null)
        toast.show({ severity: 'success', summary: 'Reprovação Cadastral', detail: 'Cadastro de ' + propriedade.nome + ' reprovado com sucesso!' })
      refresh()
    })
    .catch(logAxiosError)
}
const gerarPDFControle = async (plano: any, toast: Toast | null, refresh: Function, setLoading: Function) => {
  //console.log('gerar pdf controle')
  if (plano.rt_nome === null && toast !== null) {
    setTimeout(() => toast.show({ severity: 'error', summary: 'Geração de PDF', detail: 'Dados insuficientes para a emissão do documento: Responsável técnico indefinido!' }), 400)
    return
  }
  setLoading(true)
  axios.get(API.url + 'planos/' + plano.id + '/plano/', API.getAuthHeaders())
    .then(() => {
      toast && toast.show({ severity: 'success', summary: 'Geração de PDF', detail: 'Documento Plano de Trabalho gerado com sucesso!' })
      refresh()
      setLoading(false)
    })
    .catch((error: AxiosError) => {
      logAxiosError(error)
      toast && setTimeout(() => toast.show({ severity: 'error', summary: 'Geração de PDF', detail: error.response?.data as string }), 400)
      setLoading(false)
    })
}
const gerarPDFRequerimento = async (plano: any, toast: Toast | null, refresh: Function, setLoading: Function) => {
  //console.log('gerar pdf requerimento', plano)
  if (plano.rt_nome === null && toast !== null) {
    setTimeout(() => toast.show({ severity: 'error', summary: 'Geração de PDF', detail: 'Dados insuficientes para a emissão do documento: Responsável técnico indefinido!' }), 400)
    return
  }
  setLoading(true)
  axios.get(API.url + 'planos/' + plano.id + '/requerimento/', API.getAuthHeaders())
    .then(() => {
      toast && toast.show({ severity: 'success', summary: 'Geração de PDF', detail: 'Documento Requerimento gerado com sucesso!' })
      refresh()
      setLoading(false)
    })
    .catch((error: AxiosError) => {
      logAxiosError(error)
      toast && setTimeout(() => toast.show({ severity: 'error', summary: 'Geração de PDF', detail: error.response?.data as string }), 400)
      setLoading(false)
    })
}
const UploadAssinado = async (e: FileUploadHandlerEvent, toast: Toast | null, refresh: Function, setDisabled: Function) => {
  //console.log(e)
  const formData = new FormData()
  if (e.options.props.name === undefined) throw 'Campo "name" associado ao evento não está definido'
  formData.append(e.options.props.name, e.files[0])
  if (e.options.props.url === undefined) throw 'URL associado ao evento não está definido'
  setDisabled(true)
  axios.patch(e.options.props.url, formData, { headers: { Authorization: 'Bearer ' + Cookies.get('token') } })
    .then(() => {
      if (toast !== null) {
        toast.show({ severity: 'success', summary: 'Upload de Arquivo', detail: 'Documento ' + e.files[0].name + ' enviado com sucesso' })
      }
      refresh()
    })
    .catch(logAxiosError)
  e.options.clear()
}
const enum actionPaths {
  ar = '/aprovarreq/',
  rr = '/reprovarreq/',
  ac = '/aprovarcon/',
  rc = '/reprovarcon/'
}
const avaliarDocumento = async (plano: PlanoType, actionPath: actionPaths, toast: Toast | null, refresh: Function) => {
  axios.post(API.url + 'planos/' + plano.id + actionPath, {}, API.getAuthHeaders())
    .then((resp) => { //Usar resposta para gerar mensagem de sucesso
      if (toast !== null) {
        setTimeout(() => toast.show({ severity: 'success', summary: 'Avaliação do documento', detail: gerarRespostaAvaliação(resp.data) }), 400)
      }
      refresh()
    })
    .catch((e: AxiosError) => {
      logAxiosError(e)
      toast && setTimeout(() => {
        toast.show({ severity: 'error', summary: 'Avaliação de documento', detail: 'Erro ao avaliar documento. ' + (e.response?.data as { detail: string })?.detail })
        e.response?.status === 401 && refresh()
      }, 400)
    })
}
const gerarRespostaAvaliação = (respData: any) => {
  if (respData.requerimento_status === 'A') return 'Requerimento aprovado com sucesso'
  if (respData.requerimento_status === 'R') return 'Requerimento reprovado com sucesso'
  if (respData.controles_status === 'A') return 'Controles aprovado com sucesso'
  if (respData.controles_status === 'R') return 'Controles reprovado com sucesso'
}
// const paginatorRightPessoas = <Button type="button" icon="pi pi-download" rounded data-pr-tooltip="CSV" onClick={exportCSVPessoas} size='small' />;
export const arrendatarioTemplate = (rowData: any) => {
  return rowData.arrendatario?.pessoas_user?.[0]?.nome_razao || 'N/A'
}
export const propriedadeArrendamentoTemplate = (rowData: any) => {
  console.log('Propriedade Arrenamendo Template', rowData)
  return rowData?.lotes?.[0]?.lote.propriedade_nome || 'N/A'
}
export const DialogAprovacao = (props: Props) => {
  const auth = Auth.useAuth()
  const toast = useRef<Toast | null>(null);
  const dataTablePessoas = useRef<DataTable<any>>(null);
  const dataTablePropriedades = useRef<DataTable<any>>(null);
  const dataTableArrendamentos = useRef<DataTable<any>>(null);
  const dataTableRT = useRef<DataTable<any>>(null);
  const dataTablePlanos = useRef<DataTable<any>>(null);
  const [reprovarPessoaVisible, setReprovarPessoaVisible] = useState(false);
  const [pessoaParaReprovar, setPessoaParaReprovar] = useState<PessoaType | null>(null);
  const [motivoReprovacao, setMotivoReprovacao] = useState('');
  const [reprovarPropriedadeVisible, setReprovarPropriedadeVisible] = useState(false);
  const [propriedadeParaReprovar, setPropriedadeParaReprovar] = useState<ImovelType | null>(null);
  const [motivoReprovacaoPropriedade, setMotivoReprovacaoPropriedade] = useState('');
  const options = (pessoa: PessoaType) => (<><Button icon="pi pi-thumbs-up-fill" severity="success" onClick={() => confirmAprovar(pessoa)} /><Button icon="pi pi-thumbs-down-fill" severity="danger" onClick={() => confirmReprovarPessoa(pessoa)} /></>)
  const optionsPropriedades = (propriedade: any) => (<><Button icon="pi pi-thumbs-up-fill" severity="success" onClick={() => confirmAprovarPropriedade(propriedade)} /><Button icon="pi pi-thumbs-down-fill" severity="danger" onClick={() => confirmReprovarPropriedade(propriedade)} /></>)

  const getFirstTabIndex = () => {
    if (auth.hasPermission('monitorabahia.aprovacao_pessoas')) return 0
    if (auth.hasPermission('monitorabahia.aprovacao_propriedades')) return 1
    if (auth.hasPermission('monitorabahia.aprovacao_requerimentos')) return 2
    if (auth.hasPermission('monitorabahia.aprovacao_planos')) return 3
    if (auth.hasPermission('monitorabahia.aprovacao_arrendametos')) return 4
    if (auth.hasPermission('monitorabahia.aprovacao_rt')) return 5
    return 0
  }
  // const [planosTableData, setPlanosTableData] = useState<Array<PlanoType>>([])
  const [arrendButtonDisable, setArrendButtonDisable] = useState<boolean>(false)
  const [tabIndex, setTabIndex] = useState<number>(0)
  useEffect(() => {
    if (!props.show) return
    if (auth.hasPermission('monitorabahia.pesquisa_requerimentos')) {
      props.carregarPlanos?.()
    }
    setTabIndex(getFirstTabIndex())
  }, [props.show])
  props.propriedades.map((p) => {
    try {
      if (p.municipio_nome) return
      p.municipio_nome = props.municipios.filter((m: any) => m.id === p.municipio).length > 0 ? props.municipios.filter((m: any) => m.id === p.municipio)[0].nome : ''
    } catch (error) { }
  })
  props.propriedades.forEach((propriedade: any) => {
    try {
      if (propriedade.proprietario.nome_razao) return
      propriedade.proprietario.nome_razao = propriedade.proprietario.pessoas_user[0].nome_razao
    } catch (error) { }
  })
  const usePlanosControleTemplate = (plano: any) => {
    let buttonlist = []
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabled, setDisabled] = useState(false);
    if (!plano.controles) {
      buttonlist.push(<Button size="small" icon="pi pi-file" label='Gerar PDF' loading={isLoading} onClick={() => (confirmControlePDF(plano, setIsLoading))} ></Button>)
    } else if (plano.controles && !plano.controles_assinado) {
      buttonlist.push(<Button size="small" icon="pi pi-file-pdf" label='Abrir PDF' onClick={() => window.open(plano.controles)}></Button>)
      const uploadButtonOptions = { label: 'Assinar', icon: 'pi pi-file-edit' }
      buttonlist.push(<FileUpload
        mode='basic'
        maxFileSize={262144}
        accept='.pdf'
        disabled={isDisabled}
        auto
        customUpload
        uploadHandler={(e) => UploadAssinado(e, toast.current, props.refresh, setDisabled)}
        url={API.url + 'planos/' + plano.id + '/'}
        name='controles_assinado'
        chooseOptions={uploadButtonOptions}></FileUpload>)
    } else if (plano.controles_assinado) {
      buttonlist.push(<Button size="small" icon="pi pi-file-pdf" label='Abrir Assinado' onClick={() => window.open(plano.controles_assinado)}></Button>)
      buttonlist.push(makeStatusIcons(plano.controles_status, plano, confirmAprovarControles, confirmReprovarControles))
    }
    return buttonlist
  }
  const usePlanosRequerimentoTemplate = (plano: PlanoType) => {
    let buttonlist = []
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabled, setDisabled] = useState(false);
    if (!plano.requerimento) {
      buttonlist.push(<Button size="small" icon="pi pi-file" label='Gerar PDF' loading={isLoading} onClick={() => (confirmRequerimentoPDF(plano, setIsLoading))} ></Button>)
      // } else if (plano.requerimento && !plano.requerimento_assinado) {
      //   buttonlist.push(<Button size="small" icon="pi pi-file-pdf" label='Abrir PDF' onClick={() => plano.requerimento && window.open(plano.requerimento)}></Button>)
      //   const uploadButtonOptions = { label: 'Assinar', icon: 'pi pi-file-edit' }
      //   buttonlist.push(<FileUpload
      //     mode='basic'
      //     maxFileSize={1048576}
      //     accept='.pdf'
      //     disabled={isDisabled}
      //     auto
      //     customUpload
      //     uploadHandler={(e) => UploadAssinado(e, toast.current, props.refresh, setDisabled)}
      //     url={API.url + 'planos/' + plano.id + '/'}
      //     name='requerimento_assinado'
      //     chooseOptions={uploadButtonOptions}></FileUpload>)
      // } else if (plano.requerimento_assinado) {
      //   buttonlist.push(<Button size="small" icon="pi pi-file-pdf" label='Abrir Assinado' onClick={() => plano.requerimento_assinado && window.open(plano.requerimento_assinado)}></Button>)
      //   buttonlist.push(makeStatusIcons(plano.requerimento_status, plano, confirmAprovarRequerimento, confirmReprovarRequerimento))
    }
    return buttonlist
  }
  const makeStatusIcons = (status: STATUS, plano: PlanoType, aprovar: Function | null, reprovar: Function | null) => {
    switch (status) {
      case STATUS.NOVO:
        return <><Button icon='pi pi-thumbs-up-fill' severity='success' onClick={() => aprovar && aprovar(plano)}></Button>
          <Button icon='pi pi-thumbs-down-fill' severity='danger' onClick={() => reprovar && reprovar(plano)}></Button></>
      case STATUS.APROVADO:
        return <Avatar icon="pi pi-verified" style={{ backgroundColor: '#2196F3', color: '#ffffff' }} shape="circle" >{/*<Badge value="PJ" />*/}</Avatar>
      case STATUS.REPROVADO:
        return <Avatar icon="pi pi-times-circle" style={{ backgroundColor: '#DE2929', color: '#ffffff' }} shape="circle" >{/*<Badge value="PJ" />*/}</Avatar>
      case STATUS.ATUALIZADO:
        return <Avatar icon="pi pi-history" style={{ backgroundColor: '#D97706', color: '#ffffff' }} shape="circle" >{/*<Badge value="PJ" />*/}</Avatar>
      default:
        return <Avatar icon="pi pi-sparkles" style={{ backgroundColor: '#9c27b0', color: '#ffffff' }} shape="circle" >{/*<Badge value="PJ" />*/}</Avatar>
    }
  }
  const contratoTemplate = (a: ArrendamentoType) => {
    return <Button icon={<BiSolidFilePdf />} onClick={() => window.open(a.contrato)}></Button>
  }
  const aprovacaoArrendamentosTemplate = (a: ArrendamentoType) => {
    return a.arrendamento_final ?
      <>
        {a.arrendamento_final && `Finalizado em ${a.arrendamento_final.split('-')[2]}/${a.arrendamento_final.split('-')[1]}/${a.arrendamento_final.split('-')[0]}`}
      </>
      :
      (a.status === STATUS.APROVADO ?
        <>
          {a.avaliacao && `Aprovado em ${a.avaliacao.split('-')[2]}/${a.avaliacao.split('-')[1]}/${a.avaliacao.split('-')[0]}`}
          <Button icon={<BsCalendar2CheckFill style={{ marginRight: 10 }} />}
            onClick={() => onClickFinalizar(a.id)}>Finalizar</Button>
        </>
        : (
          a.status === STATUS.REPROVADO ?
            <>
              Reprovado em {
                a.avaliacao && `${a.avaliacao.split('-')[2]}/${a.avaliacao.split('-')[1]}/${a.avaliacao.split('-')[0]}`
              }
            </>
            :
            <div>
              <Button icon={<PiThumbsUpFill />} severity='success' disabled={arrendButtonDisable}
                onClick={() => onClickAvaliacao(a.id, STATUS.APROVADO)} />
              <Button icon={<PiThumbsDownFill />} severity='danger' disabled={arrendButtonDisable}
                onClick={() => onClickAvaliacao(a.id, STATUS.REPROVADO)} />
            </div>
        )
      )
  }
  const onClickFinalizar = async (id: number | null) => {
    if (!id) return
    setArrendButtonDisable(true)
    try {
      const response: ArrendamentoType = await API.finalizarArrendamento(id)
      const toastMessage: ToastMessage = {
        severity: 'success',
        summary: 'Avaliação de Arrendamento',
        detail: `Arrendamento foi finalizado com sucesso!`
      }
      toast.current?.show(toastMessage)
    } catch (error) {
      const e = error as AxiosError
      console.error(e)
      toast.current?.show({ severity: 'error', summary: 'Erro na Avaliação', detail: e.message })
    }
    setArrendButtonDisable(false)
    props.refresh()
  }
  const onClickAvaliacao = async (id: number | null, status: STATUS) => {
    if (!id) return
    setArrendButtonDisable(true)
    try {
      const response: ArrendamentoType = await API.avaliarArrendamento(id, status)
      const toastMessage: ToastMessage = {
        severity: 'success',
        summary: 'Avaliação de Arrendamento',
        detail: `Arrendamento foi ${response.status === 'A' ? 'aprovado' : 'reprovado'} com sucesso!`
      }
      toast.current?.show(toastMessage)
    } catch (error) {
      const e = error as AxiosError
      console.error(e)
      toast.current?.show({ severity: 'error', summary: 'Erro na Avaliação', detail: e.message })
    }
    setArrendButtonDisable(false)
    props.refresh()
  }
  const confirmControlePDF = (plano: any, setLoading: Function) => {
    messages.confirmacao(toast.current, "Deseja gerar o PDF?", 'warn', () => gerarPDFControle(plano, toast.current, props.refresh, setLoading))
  }
  const confirmRequerimentoPDF = (plano: any, setLoading: Function) => {
    messages.confirmacao(toast.current, "Deseja gerar o PDF?", 'warn', () => gerarPDFRequerimento(plano, toast.current, props.refresh, setLoading))
  }
  const confirmAprovar = (pessoa: PessoaType) => {
    messages.confirmacao(toast.current, "Tem certeza que deseja aprovar o cadastro de " + pessoa.nome_razao + "?", 'warn', () => aprovar(pessoa, toast.current, props.refresh))
  }
  const confirmAprovarPropriedade = (propriedade: ImovelType) => {
    messages.confirmacao(toast.current, "Tem certeza que deseja aprovar o cadastro de " + propriedade.nome + "?", 'warn', () => aprovarPropriedade(propriedade, toast.current, props.refresh))
  }
  const confirmReprovarPessoa = (pessoa: PessoaType) => {
    setPessoaParaReprovar(pessoa);
    setMotivoReprovacao(''); // Limpa o motivo anterior
    setReprovarPessoaVisible(true);
  }
  const reprovarPessoaAction = () => {
    if (pessoaParaReprovar) {
      reprovarPessoa(pessoaParaReprovar, motivoReprovacao, toast.current, props.refresh);
      setReprovarPessoaVisible(false);
      setPessoaParaReprovar(null);
      setMotivoReprovacao('');
    }
  }
  const confirmReprovarPropriedade = (propriedade: ImovelType) => {
    setPropriedadeParaReprovar(propriedade);
    setMotivoReprovacaoPropriedade(''); // Limpa o motivo anterior
    setReprovarPropriedadeVisible(true);
  }
  const reprovarPropriedadeAction = () => {
    if (propriedadeParaReprovar) {
      reprovarPropriedade(propriedadeParaReprovar, motivoReprovacaoPropriedade, toast.current, props.refresh);
      setReprovarPropriedadeVisible(false);
      setPropriedadeParaReprovar(null);
      setMotivoReprovacaoPropriedade('');
    }
  }
  const confirmAprovarRequerimento = (plano: PlanoType) => {
    messages.confirmacao(toast.current, 'Tem certeza que deseja aprovar este documento: Requerimento', 'warn', () => avaliarDocumento(plano, actionPaths.ar, toast.current, props.refresh))
  }
  const confirmReprovarRequerimento = (plano: PlanoType) => {
    messages.confirmacao(toast.current, 'Tem certeza que deseja reprovar este documento: Requerimento', 'warn', () => avaliarDocumento(plano, actionPaths.rr, toast.current, props.refresh))
  }
  const confirmAprovarControles = (plano: PlanoType) => {
    messages.confirmacao(toast.current, 'Tem certeza que deseja aprovar este documento: Controles', 'warn', () => avaliarDocumento(plano, actionPaths.ac, toast.current, props.refresh))
  }
  const confirmReprovarControles = (plano: PlanoType) => {
    messages.confirmacao(toast.current, 'Tem certeza que deseja reprovar este documento: Controles', 'warn', () => avaliarDocumento(plano, actionPaths.rc, toast.current, props.refresh))
  }
  const confirmAprovarRT = (pessoa: PessoaType) => {
    messages.confirmacao(toast.current, "Tem certeza que deseja aprovar o Responsável Técnico de " + pessoa.nome_razao + "?", 'warn', () => aprovarRT(pessoa, toast.current, props.refresh))
  }
  const confirmReprovarRT = (pessoa: PessoaType) => {
    messages.confirmacao(toast.current, "Tem certeza que deseja reprovar o Responsável Técnico de " + pessoa.nome_razao + "?", 'warn', () => reprovarRT(pessoa, toast.current, props.refresh))
  }
  const exportCSVPessoas = () => {
    dataTablePessoas.current&&dataTablePessoas.current.exportCSV()
  }
  const exportCSVPropriedades = () => {
    dataTablePropriedades.current&&dataTablePropriedades.current.exportCSV()
  }
  const exportCSVArrendamentos = () => {
    dataTableArrendamentos.current&&dataTableArrendamentos.current.exportCSV()
  }
  const exportCSVRT = () => {
    dataTableRT.current&&dataTableRT.current.exportCSV()
  }
  const exportCSVPlanos = () => {
    dataTablePlanos.current&&dataTablePlanos.current.exportCSV()
  }
  const tabPanelHeaderTemplate: React.FC<{ icon: IconType, text: string }> = ({ icon: IconComponent, text }) => {
    return <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><IconComponent style={{ marginRight: 5 }} />{text}</div>
  }
  const paginatorRightPessoas = <Button type="button" icon="pi pi-download" rounded data-pr-tooltip="CSV" onClick={exportCSVPessoas} size='small'/>
  const paginatorRightPropriedades = <Button type="button" icon="pi pi-download" rounded data-pr-tooltip="CSV" onClick={exportCSVPropriedades} size='small'/>
  const paginatorRightArrendamentos = <Button type="button" icon="pi pi-download" rounded data-pr-tooltip="CSV" onClick={exportCSVArrendamentos} size='small'/>
  const paginatorRightRT = <Button type="button" icon="pi pi-download" rounded data-pr-tooltip="CSV" onClick={exportCSVRT} size='small'/>
  const paginatorRightPlanos = <Button type="button" icon="pi pi-download" rounded data-pr-tooltip="CSV" onClick={exportCSVPlanos} size='small'/>

  return <Dialog header={<div style={{ display: 'flex', alignItems: 'center', height: 10 }}><AprovarIcon style={{ marginRight: 5 }} width={32} />APROVAÇÃO</div>} visible={props.show} style={{ width: 'min(100dvw, 1110px)' }} onHide={() => props.hide()}
    draggable={false} resizable={false}>
    <Toast ref={toast} position='center'></Toast>
    <TabView scrollable activeIndex={tabIndex} onTabChange={(e) => { setTabIndex(e.index) }}>
      {auth.hasPermission('monitorabahia.aprovacao_pessoas') && <TabPanel header={tabPanelHeaderTemplate({ icon: IoPeopleOutline, text: 'Pessoas' })} >
        <DataTable ref={dataTablePessoas} value={props.pessoas} stripedRows
          paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
          filterDisplay="row" sortField="nome_razao" sortOrder={1}
          selectionMode="single" onSelectionChange={(e) => props.open(e.value, false)}
          dataKey='id' tableStyle={{ minWidth: '40rem' }}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} até {last} de {totalRecords}"
          paginatorRight={paginatorRightPessoas}
        >
          <Column header='Nome | Razão Social' field="nome_razao" filter filterMatchMode={FilterMatchMode.CONTAINS} />
          <Column header='Tipo' body={tipoTemplate} />
          <Column header='CPF | CNPJ' field="cpf_cnpj" filter />
          <Column header='Cidade' field="cidade" filter filterMatchMode={FilterMatchMode.CONTAINS} />
          <Column header='Opções' body={options} exportable={false} />
        </DataTable>
      </TabPanel>}
      {auth.hasPermission('monitorabahia.aprovacao_propriedades') && <TabPanel header={tabPanelHeaderTemplate({ icon: PiFarm, text: 'Imóveis' })}>
        <DataTable ref={dataTablePropriedades} value={props.propriedades} stripedRows
          paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
          filterDisplay="row" sortField="nome" sortOrder={1}
          selectionMode="single" onSelectionChange={(e) => props.openPropriedade(e.value)}
          dataKey='id' tableStyle={{ minWidth: '40rem' }}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} até {last} de {totalRecords}"
          paginatorRight={paginatorRightPropriedades}
        >
          <Column header='Propriedade' field="nome" filter filterMatchMode={FilterMatchMode.CONTAINS} ></Column>
          <Column header='Pessoa' field='proprietario.pessoa.nome_razao' filterField='proprietario.nome_razao' filter filterMatchMode={FilterMatchMode.CONTAINS}></Column>
          <Column header='Municipio' field='municipio_nome' filterField='municipio_nome' filter filterMatchMode={FilterMatchMode.CONTAINS}></Column>
          <Column header='Documentação' body={(rowData: ImovelType) => rowData.doc_matricula ? <Button icon="pi pi-file-pdf" onClick={() => window.open(rowData.doc_matricula)} /> : 'N/A'} />
          <Column header='Opções' body={optionsPropriedades} exportable={false} />
        </DataTable>
      </TabPanel>}
      {auth.hasPermission('monitorabahia.pesquisa_arrendamentos') && <TabPanel header={tabPanelHeaderTemplate({ icon: PiReceipt, text: 'Arrendamentos' })} >
        <DataTable value={props.arrendamentos.filter((a) => a.arrendatario.id === auth.user?.id)} stripedRows filterDisplay="row"
          ref={dataTableArrendamentos} paginator paginatorRight={paginatorRightArrendamentos}>
          <Column header='Propriedade' body={propriedadeArrendamentoTemplate} filter></Column>
          <Column header='Arrendatario' body={arrendatarioTemplate} filter></Column>
          <Column header='Inicio' field='arrendamento_inicio' filter></Column>
          <Column header='Contrato' body={contratoTemplate} filter></Column>
          <Column header='Ações' body={aprovacaoArrendamentosTemplate}></Column>
        </DataTable>
      </TabPanel>}
      {auth.hasPermission('monitorabahia.aprovacao_rt') && <TabPanel header={tabPanelHeaderTemplate({ icon: PiIdentificationBadgeFill, text: 'Responsável Técnico' })}>
        <DataTable value={props.rts} stripedRows ref={dataTableRT}
          paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
          filterDisplay="row" sortField="nome_razao" sortOrder={1}
          dataKey='id' tableStyle={{ minWidth: '40rem' }}
          paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
          currentPageReportTemplate="{first} até {last} de {totalRecords}" paginatorRight={paginatorRightRT}
        >
          <Column header='Nome | Razão Social' field="nome_razao" filter filterMatchMode={FilterMatchMode.CONTAINS} />
          <Column header='Conselho' field="conselho_rt" filter filterMatchMode={FilterMatchMode.CONTAINS} />
          <Column header='UF' field="conselho_uf" filter filterMatchMode={FilterMatchMode.CONTAINS} />
          <Column header='Registro' field="registro_rt" filter filterMatchMode={FilterMatchMode.CONTAINS} />
          <Column header='Carteira' body={(rowData: PessoaType) => rowData.doc_rt ? <Button icon="pi pi-file-pdf" onClick={() => rowData.doc_rt && window.open(rowData.doc_rt)} /> : 'N/A'} />
          <Column header='Opções' body={(rowData: PessoaType) => (<><Button icon="pi pi-thumbs-up-fill" severity="success" onClick={() => confirmAprovarRT(rowData)} /><Button icon="pi pi-thumbs-down-fill" severity="danger" onClick={() => confirmReprovarRT(rowData)} /></>)} exportable={false} />
        </DataTable>
      </TabPanel>}
      {auth.hasPermission('monitorabahia.aprovacao_requerimentos') && <TabPanel header={tabPanelHeaderTemplate({ icon: PiListChecks, text: 'Requerimentos' })}>
        <DataTable
          ref={dataTablePlanos} paginator paginatorRight={paginatorRightPlanos}
          value={props.planos}
          stripedRows filterDisplay="row"
          style={{ display: 'flex', flexDirection: 'column'}} tableStyle={{ tableLayout: 'fixed' }}>
          <Column header='Propriedade' body={(plano: PlanoType) => plano.propriedade.nome} filter filterMatchMode={FilterMatchMode.CONTAINS} headerStyle={{ width: '16rem' }} bodyStyle={{ overflowWrap: 'break-word' }}></Column>
          <Column header='Culturas' body={(plano: PlanoType) => (plano.plantios?.map((plantio) => plantio.cultura))?.join(' ') || ''} filter filterMatchMode={FilterMatchMode.CONTAINS} headerStyle={{ width: '11rem' }} bodyStyle={{ overflowWrap: 'break-word' }}></Column>
          <Column header='Lotes' body={(plano: PlanoType) => plano.plantios?.map((plantio) => plantio.lotes?.map((lote) => lote.id)?.join(' '))?.join(' ')} filter filterMatchMode={FilterMatchMode.EQUALS} headerStyle={{ width: '10rem' }} bodyStyle={{ overflowWrap: 'break-word' }}></Column>
          <Column header='Responsável Técnico' body={(plano: PlanoType) => plano.responsavel_tecnico.pessoa.nome_razao} filter filterMatchMode={FilterMatchMode.CONTAINS} headerStyle={{ width: '13rem' }} bodyStyle={{ overflowWrap: 'break-word' }}></Column>
          <Column header='Documentação' field='requerimento_status' filter body={usePlanosRequerimentoTemplate} headerStyle={{ width: '10rem' }}></Column>
        </DataTable>
      </TabPanel>}
      {auth.hasPermission('monitorabahia.aprovacao_planos') && <TabPanel header={tabPanelHeaderTemplate({ icon: PiBriefcase, text: 'Plano de Trabalho' })}>
        <DataTable
          // value={planosTableData} 
          stripedRows filterDisplay="row" paginator paginatorRight={paginatorRightPlanos}
          style={{ display: 'flex', flexDirection: 'column' }} tableStyle={{ tableLayout: 'fixed' }}>
          <Column header='Propriedade' field='propriedade_nome' filter filterMatchMode={FilterMatchMode.CONTAINS} headerStyle={{ width: '16rem' }} bodyStyle={{ overflowWrap: 'break-word' }}></Column>
          <Column header='Culturas' field='culturas' filter filterMatchMode={FilterMatchMode.CONTAINS} headerStyle={{ width: '11rem' }} bodyStyle={{ overflowWrap: 'break-word' }}></Column>
          <Column header='Lotes' field='lotes_numero' filter filterMatchMode={FilterMatchMode.EQUALS} headerStyle={{ width: '10rem' }} bodyStyle={{ overflowWrap: 'break-word' }}></Column>
          <Column header='Responsável Técnico' field='rt_nome' filter filterMatchMode={FilterMatchMode.CONTAINS} headerStyle={{ width: '13rem' }} bodyStyle={{ overflowWrap: 'break-word' }}></Column>
          <Column header='Documentação' field='controles_status' body={usePlanosControleTemplate} filter headerStyle={{ width: '10rem' }}></Column>
        </DataTable>
      </TabPanel>}
    </TabView>
    <Dialog header="Motivo da Reprovação" visible={reprovarPessoaVisible} style={{ width: '50vw' }} onHide={() => setReprovarPessoaVisible(false)} footer={
      <div>
        <Button label="Cancelar" icon="pi pi-times" onClick={() => setReprovarPessoaVisible(false)} className="p-button-text" />
        <Button label="Confirmar" icon="pi pi-check" onClick={reprovarPessoaAction} autoFocus />
      </div>
    }>
      <div className="p-fluid">
        <div className="p-field">
          <label htmlFor="motivo">Motivo</label>
          <InputTextarea id="motivo" value={motivoReprovacao} onChange={(e) => setMotivoReprovacao(e.target.value)} rows={5} />
        </div>
      </div>
    </Dialog>
    <Dialog header="Motivo da Reprovação" visible={reprovarPropriedadeVisible} style={{ width: '50vw' }} onHide={() => setReprovarPropriedadeVisible(false)} footer={
      <div>
        <Button label="Cancelar" icon="pi pi-times" onClick={() => setReprovarPropriedadeVisible(false)} className="p-button-text" />
        <Button label="Confirmar" icon="pi pi-check" onClick={reprovarPropriedadeAction} autoFocus />
      </div>
    }>
      <div className="p-fluid">
        <div className="p-field">
          <label htmlFor="motivo">Motivo</label>
          <InputTextarea id="motivo" value={motivoReprovacaoPropriedade} onChange={(e) => setMotivoReprovacaoPropriedade(e.target.value)} rows={5} />
        </div>
      </div>
    </Dialog>
  </Dialog>
}
